import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, darken, Link, Typography } from '@mui/material';
import { ColumnBox } from 'shared/components/containers';
import { htmlFromString } from 'console/shared/utils/parse-html';
const sx = {
    overflowX: 'auto',
};
const imgRegExp = /.*\.(?:jpg|jpeg|gif|png)$/;
const parseWithAttachment = (msg) => {
    const { url, text } = msg;
    if (url) {
        if (text.match(imgRegExp)) {
            return _jsx("img", { src: url, alt: text });
        }
        return (_jsx(Link, { target: "_blank", rel: "noreferrer", underline: "always", href: url, children: text }));
    }
    return htmlFromString(text);
};
export const SupportChatMessageItem = memo(function SupportChatMessageItem(props) {
    const { msg } = props;
    const { author, author_is_support, time } = msg;
    return (_jsxs(ColumnBox, { alignSelf: author_is_support ? '' : 'flex-end', gap: 0.5, sx: (theme) => ({
            width: '90%',
            position: 'relative',
            right: 0,
            bgcolor: author_is_support
                ? darken(theme.palette.background.default, 0.2)
                : 'background.default',
            p: 2,
            pb: 0.5,
        }), children: [_jsx(Box, { display: "flex", justifyContent: "space-between", children: _jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: author }) }), _jsx(Box, { className: "support-chat-message", sx: sx, children: parseWithAttachment(msg) }), _jsx(Box, { display: "flex", justifyContent: "flex-end", children: _jsx(Typography, { variant: "body2", color: "textSecondary", children: time }) })] }));
});
